var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_119",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11080",
    "data-name": "Group 11080",
    transform: "translate(-284 -303)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 284, 303)",
    filter: "url(#Ellipse_119)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_119-2",
    "data-name": "Ellipse 119",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(9 6)",
    fill: "#437cf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11068",
    "data-name": "Group 11068",
    transform: "translate(304.148 317.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-attach-money",
    "data-name": "Icon material-attach-money",
    d: "M14.819,12.2C12.607,11.622,11.9,11.027,11.9,10.1c0-1.062.984-1.8,2.63-1.8,1.734,0,2.377.828,2.436,2.046h2.153a3.884,3.884,0,0,0-3.127-3.712V4.5H13.065V6.6c-1.89.409-3.41,1.637-3.41,3.517,0,2.25,1.861,3.371,4.579,4.024,2.436.585,2.923,1.442,2.923,2.348,0,.672-.477,1.744-2.63,1.744-2.007,0-2.8-.9-2.9-2.046H9.48a4.082,4.082,0,0,0,3.585,3.731v2.114h2.923V19.942c1.9-.36,3.41-1.461,3.41-3.459C19.4,13.716,17.03,12.771,14.819,12.2Z",
    transform: "translate(-9.48 -4.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-coins",
    "data-name": "Icon awesome-coins",
    d: "M0,14.32v1.509c0,1.247,3.039,2.261,6.784,2.261s6.784-1.014,6.784-2.261V14.32c-1.459,1.028-4.127,1.509-6.784,1.509S1.459,15.348,0,14.32Zm11.306-9.8c3.745,0,6.784-1.014,6.784-2.261S15.051,0,11.306,0,4.523,1.014,4.523,2.261,7.561,4.523,11.306,4.523ZM0,10.614v1.823C0,13.684,3.039,14.7,6.784,14.7s6.784-1.014,6.784-2.261V10.614c-1.459,1.2-4.13,1.823-6.784,1.823S1.459,11.815,0,10.614ZM14.7,11c2.025-.392,3.392-1.12,3.392-1.957V7.536A8.676,8.676,0,0,1,14.7,8.755ZM6.784,5.653C3.039,5.653,0,6.918,0,8.48s3.039,2.827,6.784,2.827,6.784-1.265,6.784-2.827S10.529,5.653,6.784,5.653Zm7.748,1.989c2.12-.382,3.558-1.131,3.558-1.989V4.144a11.5,11.5,0,0,1-5.678,1.477A3.957,3.957,0,0,1,14.532,7.642Z",
    transform: "translate(7.734 12.016)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudget);
export default __webpack_public_path__ + "static/media/budget.6befd5f01f3e51b3bb8a82058236d084.svg";
export { ForwardRef as ReactComponent };